<template>
  <div>
    <StaticDataTable class="static-table-list" :striped="false" :hover="false">
      <template v-slot:header>
        <tr>
          <th width="40%">{{nameTitle}}</th>
          <th>{{valueTitle}}</th>
          <th width="0%" v-if="editing"> </th>
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="(item, index) of lookupList" :key="index">
          <td>
            <FormInputText v-if="editing" v-model="item[nameField]" @input="listUpdated" :placeholder="nameTitle" />
            <span v-if="!editing">{{item[nameField]}}</span>
          </td>
          <td>
            <FormInputText v-if="editing" v-model="item[valueField]" @input="listUpdated" :placeholder="valueTitle" />
            <span v-if="!editing">{{item[valueField]}}</span>
          </td>
          <td>
            <ActionDropMenu :tableAction="true" v-if="editing">
              <DropdownMenuItem @click="removeLookupItem(index)" icon="fa-trash-alt">Remove</DropdownMenuItem>
            </ActionDropMenu>
          </td>
        </tr>
      </template>
      <template v-slot:empty v-if="lookupList.length == 0">
        {{lookupListEmptyMessage}}
      </template>
    </StaticDataTable>
    <div v-if="addItemsEnabled && editing">
      <FormButton @click="addItem" class="btn-default btn-xs"><i class="far fa-plus-circle"></i> Add Item</FormButton>
    </div>
  </div>
</template>


<script>
import _ from 'lodash'

export default {
  name: 'FormLookupTable',
  model: {
    event: 'update'
  },
  props: {
    value: Array,
    nameField: {
      type: String,
      default: 'name'
    },
    nameTitle: {
      type: String,
      default: 'Name'
    },
    valueField: {
      type: String,
      default: 'value'
    },
    valueTitle: {
      type: String,
      default: 'Value'
    },
    lookupListEmptyMessage: {
      type: String,
      default: 'Lookup list is empty'
    },
    editing: Boolean,
    addItemsEnabled: Boolean
  },
  data() {
    return {
      lookupList: this.value || []
    }
  },
  watch: {
    value: function() {
      this.lookupList = this.value || []
    }
  },
  methods: {
    updateItemName(index, name) {
      this.lookupList[index][this.nameField] = name
      this.listUpdated()
    },
    updateItemValue(index, value) {
      this.lookupList[index][this.valueField] = value
      this.listUpdated()
    },
    removeLookupItem(index) {
      this.lookupList.splice(index, 1)
      this.listUpdated()
    },
    addItem() {
      this.lookupList.push({
        [this.nameField]: '',
        [this.valueField]: ''
      })
      this.listUpdated()
    },
    listUpdated() {
      //this.$emit('update', this.lookupList)
    }
  }
}
</script>